import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "text-sm font-medium" }
const _hoisted_3 = { class: "absolute right-0 mt-2 w-32 bg-white rounded-lg shadow-lg border z-50" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      class: "flex items-center space-x-2 px-3 py-2 rounded-lg bg-white shadow-md hover:shadow-lg transition-shadow border"
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "currentColor",
        viewBox: "0 0 20 20"
      }, [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M7 2a1 1 0 011 1v1h3a1 1 0 110 2H9.578a18.87 18.87 0 01-1.724 4.78c.29.354.596.696.914 1.026a1 1 0 11-1.44 1.389c-.188-.196-.373-.396-.554-.6a19.098 19.098 0 01-3.107 3.567 1 1 0 01-1.334-1.49 17.087 17.087 0 003.13-3.733 18.992 18.992 0 01-1.487-2.494 1 1 0 111.79-.89c.234.47.489.928.764 1.372.417-.934.752-1.913.997-2.927H3a1 1 0 110-2h3V3a1 1 0 011-1zm6 6a1 1 0 01.894.553l2.991 5.982a.869.869 0 01.02.037l.99 1.98a1 1 0 11-1.79.895L15.383 16h-4.764l-.724 1.447a1 1 0 11-1.788-.894l.99-1.98.019-.038 2.99-5.982A1 1 0 0113 8zm-1.382 6h2.764L13 12.236 11.618 14z",
          "clip-rule": "evenodd"
        })
      ], -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.currentLanguage), 1),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["w-4 h-4 transition-transform", { 'rotate-180': _ctx.isOpen }]),
        fill: "currentColor",
        viewBox: "0 0 20 20"
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
          "clip-rule": "evenodd"
        }, null, -1)
      ]), 2))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
        return (_openBlock(), _createElementBlock("button", {
          key: lang.code,
          onClick: ($event: any) => (_ctx.changeLanguage(lang.code)),
          class: _normalizeClass(["w-full px-4 py-2 text-left text-sm hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg flex items-center space-x-2", { 'bg-blue-50 text-blue-600': _ctx.currentLocale === lang.code }])
        }, [
          _createElementVNode("span", null, _toDisplayString(lang.flag), 1),
          _createElementVNode("span", null, _toDisplayString(lang.name), 1)
        ], 10, _hoisted_4))
      }), 128))
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ]))
}